import React from 'react'
import Session from './Session'

const Sessions = ({sessions}) => {
    if(sessions === null || sessions.length === 0) return null
    return (
        <>
            {sessions.map((item, index) => {
                return (                
                   <Session item={item} index={index} key={"session-"+ index}/>
                )
            })}
        </>
    )
}

export default Sessions;